import { inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideTuiEditor, provideTuiEditorOptions, TuiEditor } from '@taiga-ui/editor';
import { TranslateModule } from '@ngx-translate/core';
import { EnvService } from '@src/app/modules/env';

import { MessageInputComponent } from './message-input.component';

@NgModule({
  declarations: [MessageInputComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TuiEditor, TranslateModule],
  providers: [
    provideTuiEditor({}, async () =>
      import('@taiga-ui/editor').then(({ TuiMarkdown }) =>
        TuiMarkdown.configure({
          linkify: true, // INFO: Create links from "https://..." text. Используется для распознавания вставленных ссылок
          transformPastedText: true, // INFO: Allow to paste markdown text in the editor. Используется для распознавания вставленных ссылок
        }),
      ),
    ),
    provideTuiEditorOptions(() => {
      const env = inject(EnvService);

      return {
        editorProps: {
          handleDOMEvents: {
            keydown: (_, event: KeyboardEvent) => {
              if (event.key === 'Enter' && !event.shiftKey && !env.isMobilePlatform) {
                event.preventDefault();
              }
            },
          },
        },
      };
    }),
  ],
  exports: [MessageInputComponent],
})
export class MessageInputModule {}
